export default __webpack_public_path__ + "static/media/flowers_two.80c43281.svg";